import { useRef } from 'react';
import papers from "../images/papers.png"
import backgroundImageUrl from "../images/15.png";
import mobilebackgroundImageUrl from "../images/21.png";
import transformationImageUrl from "../images/16.png";
import healingImageUrl from "../images/17.png";
import Footer from '../components/Footer';
import { FaArrowRight, FaMailBulk } from 'react-icons/fa';
import Header from '../components/Header';
import awardImage from "../images/18.png";
import learnMoreImage from "../images/19.png";
import Testimonials from '../components/Testimonials';
import {
    FaFacebook,
    FaInstagram,
    FaLinkedin,
} from 'react-icons/fa';

function Contact() {

    return (
        <div className="mb-[120px] md:mb-0">
            <Header pageName="Contact Us" />
            <div className="background-with-image-blue pt-32 hidden md:block"></div>
            <div className="background-with-image-blue">
                <div className="container mx-auto py-16 pt-32 px-8 ">
                    <section className="flex flex-col md:flex-row items-center justify-end text-white">
                        <div className="w-full md:w-1/2 md:pr-12">
                            <h2 className="eb-garamond text-3xl font-serif mb-8 md:leading-relaxed max-w-prose">
                                FOR INQUIRIES:
                            </h2>
                            <h2 className="eb-garamond text-3xl md:text-4xl font-serif mb-8 md:leading-relaxed max-w-prose">
                                <FaMailBulk className='mt-2 md:mt-4 mr-4' style={{
                                    float: 'left'
                                }} /> iram@iramkhoker.com
                            </h2>
                            <h2 className="eb-garamond text-3xl font-serif mb-4 md:leading-relaxed max-w-prose">
                                OR FIND US ON OUR SOCIALS:
                            </h2>
                            <div className={`flex space-x-6 text-white mt-0`}>
                                <a href="#" aria-label="Facebook" className='text-3xl ' >
                                    <FaFacebook />
                                </a>
                                <a href="#" aria-label="Instagram" className='text-3xl '>
                                    <FaInstagram />
                                </a>
                                <a href="#" aria-label="LinkedIn" className='text-3xl '>
                                    <FaLinkedin />
                                </a>
                            </div>
                        </div>
                        <div className="w-full md:w-1/2">
                            <h2 className="eb-garamond text-3xl font-serif mb-8 md:leading-relaxed max-w-prose">
                                To recieve program material:
                            </h2>
                            <div className="w-full flex flex-col gap-5 mt-8 md:mt-0 mx-auto">
                                <input className='w-full p-4 text-black poppins rounded' placeholder='Enter Name' />
                                <input className='w-full p-4 text-black poppins rounded' placeholder='Enter Email' />
                                <input className='w-full p-4 text-black poppins rounded' placeholder='Enter Phone Number' />
                                <textarea className='w-full p-4 text-black poppins min-h-[200px] rounded' placeholder='Enter Message'></textarea>
                                <button className='w-full font-semibold text-lg rounded-full text-[#f15d16] hover:text-white border-2 border-white bg-white hover:bg-[#f15d16] poppins transition duration-300 py-2'>Send Message</button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <div className="background-with-image">
                <div className='container mx-auto py-16 md:py-32 flex flex-col md:flex-row items-center justify-center relative'>
                    {/* Your email subscribe form or other content here */}
                    {/* Pinned notes */}
                    <div className="w-lg md:w-1/3 z-10 relative cursor-default select-none">
                        <img
                            src={papers}
                            alt="Logo"
                            className="mb-3 md:mr-12 w-[200px] md:w-[300px] object-contain"
                        />
                    </div>

                    {/* Email input */}
                    <form className="w-[80%] mt-16 md:mt-0 md:w-2/3 z-10 flex items-center bg-white rounded-full shadow-lg overflow-hidden md:max-w-md md:w-full">
                        <input
                            type="email"
                            placeholder="EMAIL ADDRESS"
                            className="flex-grow px-4 py-3 text-sm italic text-gray-400 placeholder-gray-400 focus:outline-none"
                            aria-label="Email Address"
                            required
                        />
                        <button
                            type="submit"
                            className="bg-[#80a2a5] p-[5px] mr-[5px] border-2 border-[#80a2a5] hover:bg-transparent hover:text-[#80a2a5] rounded-full transition duration-300"
                            aria-label="Submit email"
                        >
                            <FaArrowRight />
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default Contact;